const apiKey = 'AIzaSyBfAaql-qYynRiaGy9UApPYf_IcnlDSrGk';
const src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
const mapStyles = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#212121",
            },
        ],
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off",
            },
        ],
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575",
            },
        ],
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#212121",
            },
        ],
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#757575",
            },
        ],
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e",
            },
        ],
    },
    {
        "featureType": "administrative.land_parcel",
        "stylers": [
            {
                "visibility": "off",
            },
        ],
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd",
            },
        ],
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575",
            },
        ],
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#181818",
            },
        ],
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161",
            },
        ],
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1b1b1b",
            },
        ],
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#2c2c2c",
            },
        ],
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#8a8a8a",
            },
        ],
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#373737",
            },
        ],
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#3c3c3c",
            },
        ],
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#4e4e4e",
            },
        ],
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161",
            },
        ],
    },
    {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575",
            },
        ],
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000",
            },
        ],
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#3d3d3d",
            },
        ],
    },
];
const svgPath = "M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z";

function loadMap(locations, panX = 0, panY = 0) {
    createGmapsScript();

    // check if google maps api is loaded
    if (typeof google === 'object' && typeof google.maps === 'object') {
        initMap(locations, panX, panY);
    } else {
        // interval to check if google maps api is loaded
        const interval = setInterval(() => {
            if (typeof google === 'object' && typeof google.maps === 'object') {
                clearInterval(interval);

                initMap(locations, panX, panY);
            }
        });
    }
}

function initMap(locations, panX, panY) {
    const svgMarker = {
        path: svgPath,
        fillColor: "rgb(255,204,0)",
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 2,
        anchor: new google.maps.Point(12, 24),
    };

    // Create map objects and specify the DOM element for display.
    if (Array.isArray(locations)) {
        // for many locations
        locations.forEach((l) => {
            const latlng = {lat: l['lat'], lng: l['lng']};

            const map = new google.maps.Map(document.getElementById(`map_${l['place_id']}`), {
                center: latlng,
                zoom: l['zoom'],
                styles: mapStyles,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: true,
                fullscreenControlOptions: {
                    position: google.maps.ControlPosition.LEFT_TOP,
                },
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_TOP,
                },
            });

            if (window.matchMedia("(min-width: 768px)").matches) {
                map.panBy(panX, panY);
            }

            const marker = new google.maps.Marker({
                position: map.getCenter(),
                map,
                icon: svgMarker,
                title: l['title'],
            });
            marker.setMap(map);
        });
    }
}

function createGmapsScript() {
    if (!document.querySelectorAll(`script[src="${src}"]`).length > 0) {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        const head = document.getElementsByTagName('head')[0];
        const insertBefore = head.insertBefore;
        head.insertBefore = function (newElement, referenceElement) {
            if (newElement.href && (newElement.href.indexOf('//fonts.googleapis.com/css?family=Roboto')) > -1) {
                return;
            }
            if (newElement.href && (newElement.href.indexOf('//fonts.googleapis.com/css?family=Google+Sans+Text')) > -1) {
                return;
            }
            insertBefore.call(head, newElement, referenceElement);
        };
        document.head.appendChild(script);
    }
}

export default loadMap;
